var heading_default = {
  "fontElementMap": "_4jGJD",
  "elementSpacing": "C7B6W",
  "headerOne": "_83S3H C7B6W",
  "headerTwo": "_5Tq-n C7B6W",
  "headerThree": "Oh67k C7B6W",
  "headerFour": "G82XS C7B6W",
  "headerFive": "SZ-0M C7B6W",
  "headerSix": "sYlyb C7B6W",
  "child": "_0vL30"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
